import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { EXPORT_WATCH_LIST_ALL_ENTRIES_CSV } from '../types';
import { EXPORT_WATCH_LIST_All_ENTRIES_CSV_MESSAGES } from '../constants/exportWatchListEntriesCsvMessages';
import { exportWatchListAllEntriesCsvPending, exportWatchListAllEntriesCsvFulfilled, exportWatchListAllEntriesCsvRejected } from '../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'WatchList/GetAllWatchListEntriesExportCsv',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(EXPORT_WATCH_LIST_All_ENTRIES_CSV_MESSAGES.NOT_FOUND)
    : exportWatchListAllEntriesCsvFulfilled(response))],
  onError: [
    exportWatchListAllEntriesCsvRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'pdfApi',
};

const exportWatchListAllEntriesCsvEpic$ = (action$, state$) => action$.pipe(
  ofType(EXPORT_WATCH_LIST_ALL_ENTRIES_CSV.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(exportWatchListAllEntriesCsvPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),

);

export default exportWatchListAllEntriesCsvEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/exportWatchListAllEntriesCsvEpic.js